import React, { useEffect, useRef } from "react";
import $ from "jquery";

import GBTSLogoSvg from "../../assets/GBTSLogoSvg";

import BuddibleSocket from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function FindID() {
  const { t, i18n } = useTranslation();
  const $controllers = {
    USER_NM: useRef(),
    USER_TEL: useRef(),
  };

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
  }, []);

  function joinData(key, data) {
    let retData = {
      COMP_CD: "Y0001",
      USER_NM: $controllers.USER_NM.current.value,
      USER_TEL: $controllers.USER_TEL.current.value,
    };

    if (key === "METHOD") {
      retData.METHOD = data;
    }

    return retData;
  }

  function actionSubmit() {
    let updateData = joinData("METHOD", "FIND_EMAIL");
    requestUserUpdate(updateData);
  }

  function checkValidation(updateData) {
    if (updateData.METHOD === "FIND_EMAIL") {
      if (updateData.USER_NM.trim() === "") {
        codeList.Modal.current.alert(t("commonMSG.enterName"), () => {
          $controllers.USER_NM.current.focus();
        });
        return false;
      }

      if (util.validationMobileNumber(updateData.USER_TEL) === false) {
        codeList.Modal.current.alert(t("commonMSG.enterPhoneNumber"), () => {});
        return false;
      }
    } else {
      return false;
    }

    return true;
  }

  function requestUserUpdate(updateData) {
    if (checkValidation(updateData) === false) return;

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/join/JS_join_gbts_private_find_id.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };

    if (socketMsg.USER_PW) {
      socketMsg.USER_PW = util.buddibleEncrypt(socketMsg.USER_PW);
    }
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        switch (updateData.METHOD) {
          case "FIND_EMAIL":
            if (newData["ret"] === true) {
              if (newData["returnData"].length !== 0) {
                codeList.Modal.current.alert(
                  `${t("find.msg.findIDPrev")}${
                    newData["returnData"][0].USER_ID
                  }${t("find.msg.findIDNext")}`,
                  () => {}
                );
              } else {
                codeList.Modal.current.alert(t("find.msg.noEmail"), () => {});
              }
            } else {
              codeList.Modal.current.alert(t("commonMSG.error"), () => {});
            }

            break;
        }
      }
    });
  }

  return (
    <div className="vh-100 d-flex flex-column align-items-center justify-content-center bg-light">
      <GBTSLogoSvg height={60} />
      <p className="mt-2 mb-3 h5 font-weight-bold text-secondary">
        {t("find.id.title")}
      </p>
      <div className="bg-white p-2 rounded shadow-sm" style={{ maxWidth: 535 }}>
        <div className="container-fluid">
          <div className="py-3 d-block">
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("find.id.name")}
              </label>
              <div className="col-sm-9">
                <input
                  type="email"
                  className="form-control"
                  ref={$controllers.USER_NM}
                />
              </div>
            </div>
            <div className="row">
              <label className="col-form-label col-sm-3 text-end">
                {t("find.id.phoneNumber")}
              </label>
              <div className="col-sm-9">
                <input
                  type="tel"
                  className="form-control"
                  ref={$controllers.USER_TEL}
                />
              </div>
            </div>
          </div>
          <div className="text-danger mb-3">{t("find.id.notice")}</div>
          <div className="text-right mb-2">
            <button type="button" className="btn_1" onClick={actionSubmit}>
              {t("find.id.submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
